import type { QueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from 'api/constants';

import { IMPORTS_IN_PROGRESS_STORE } from './store';

/**
 * After a dropped connection is restored, we may have missed an `ImportCompleted`, so re-enable the
 * polling fallback for every tracked import and invalidate the imports queries to refetch and
 * reconcile them. React Query's invalidateQueries only eagerly refetches active (mounted) queries,
 * so projects the user isn't looking at won't refetch until mounted.
 */
export function reconcileImportsAfterReconnect(queryClient: QueryClient) {
  IMPORTS_IN_PROGRESS_STORE.getState().markAllImportsNeedPolling();
  queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.ALL_IMPORTS] });
}
